/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebComponents {
    "use strict";

    export class DateMonthYearDirectiveController {
        public static $inject: string[] = [ ];

        public monthYear            : any;
        public placeholder          : string;
        public minDate              : Date;
        public maxDate              : Date;
        public hideButtons          : boolean;
        public locale               : any;
        public onCancel             : any;
        public onClear              : any;
        public onApply              : any;
        public checkIsCancelDisabled: any;
        public checkIsClearDisabled : any;
        public checkIsApplyDisabled : any;

        constructor() {
            var monthDateFormat = 'MMMM, YYYY';
            this.locale = {
                formatDate: ( date: any ) => {
                    if (date) {
                        return moment(date).format(monthDateFormat);
                    }
                    return null;
                },
                parseDate: ( dateString: string ) => {
                    if (dateString) {
                        var m = moment(dateString, monthDateFormat, true);
                        return m.isValid() ? m.toDate() : new Date();
                    }
                    return null;
                }
            };


        }

        public cancel() : void {
            if (this.onCancel && angular.isFunction(this.onCancel)) {
                this.onCancel();
            }
        }

        public clear() : void {
            if (this.onClear && angular.isFunction(this.onClear)) {
                this.onClear();
            }
        }

        public apply() : void {
            if (this.onApply && angular.isFunction(this.onApply)) {
                this.onApply();
            }
        }

        public isCancelDisabled () : boolean {

            if (this.checkIsCancelDisabled && angular.isFunction(this.checkIsCancelDisabled)) {
                return this.checkIsCancelDisabled();
            }

            return false;
        }

        public isClearDisabled () : boolean {

            if (this.checkIsClearDisabled && angular.isFunction(this.checkIsClearDisabled)) {
                return this.checkIsClearDisabled();
            }

            return false;
        }

        public isApplyDisabled () : boolean {

            if (this.checkIsApplyDisabled && angular.isFunction(this.checkIsApplyDisabled)) {
                return this.checkIsApplyDisabled();
            }

            return false;
        }
    }

    getDealerwareWebComponentsModule().controller('DateMonthYearDirectiveController', DateMonthYearDirectiveController);

    export class DateMonthDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'DateMonthYearDirectiveController';
        public controllerAs     : string    =   'vm';
        public bindToController : boolean   =   true;
        public templateUrl      : string    =   '/components/date_input/month_year/date_input_directive.html';
        public scope            : Object    =   {
            monthYear               : '=',
            placeholder             : '@?',
            minDate                 : '=?',
            maxDate                 : '=?',
            hideButtons             : '=?',
            onCancel                : '&',
            onClear                 : '&?',
            onApply                 : '&',
            checkIsCancelDisabled   : '&?',
            checkIsClearDisabled    : '&?',
            checkIsApplyDisabled    : '&?'
        };
    }

    getDealerwareWebComponentsModule().directive('dealerwareDateMonthYear',
        () => new DateMonthDirective()
    );
 }
